import { Injectable } from '@angular/core';
import {
  INimChallengeParams,
  INimLoginParams,
  INimLoginResponse,
  INimRegisterParams,
  INimRegisterResponse
} from './auth.model';
import { Observable, throwError } from "rxjs";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { catchError, map, take } from "rxjs/operators";
import { Config } from "../universal-config";

@Injectable({
  providedIn: 'root'
})
export class NimAuthApiClientService {
  shareApiService;

  constructor(
    private http: HttpClient,
    private _config: Config,
  ) {
    this.shareApiService = this._config.get('SHARE_API_SERVICE');
  }

  private handleError(error: HttpErrorResponse) {
    if (error.status === 0) {
      console.error('An error occurred:', error.error);
    } else {
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    return throwError('Something bad happened; please try again later.');
  }

  login(loginParams: INimLoginParams, apiUrl: string): Observable<INimLoginResponse> {
    return this.http
      .post<{body: INimLoginResponse, errorCode: number}>(`${apiUrl}/auth`, loginParams)
      .pipe(
        map((result) => {
          return {
            sessionId: result.body.sessionId,
            errorCode: result.errorCode,
            body: result.body,
          };
        }),
        catchError(this.handleError)
      );
  }

  register(
    registerParams: INimRegisterParams,
    apiUrl: string,
  ): Observable<INimRegisterResponse> {
    return this.http
      .post<{body: INimRegisterResponse, errorCode: number}>(`${apiUrl}/register`, {
        ...registerParams,
        service: 'nimbus',
      }, {
        headers: {
          'x-client-software': 'web_share'
        },
      })
      .pipe(
        map((result) => {
          return {
            id: result.body.id,
            sessionId: result.body.sessionId,
            errorCode: result.errorCode,
            body: result.body,
          };
        }),
        catchError(this.handleError)
      );
  }

  challenge(
    challengeParams: INimChallengeParams,
    apiUrl: string,
  ): Observable<INimLoginResponse> {
    return this.http
      .post<{body: INimLoginResponse, errorCode: number}>(`${apiUrl}/challenge`, {
        ...challengeParams,
        service: 'nimbus',
      })
      .pipe(
        map((result) => {
          return {
            sessionId: result.body.sessionId,
            errorCode: result.errorCode,
            body: result.body,
          };
        }),
        catchError(this.handleError)
      );
  }
}
